import { taggedTemplateLiteral as _taggedTemplateLiteral, toConsumableArray as _toConsumableArray } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import styled from '../../theming/styled-components.js';
import themes from '../../theming/themes.js';
import React, { memo, useContext } from 'react';
import withDefaultTheme from '../../hocs/withDefaultTheme.js';
import _TableHeaderCol from '../../components/Table/TableHeaderCol.js';
import _TableRow from '../../components/Table/TableRow.js';
import TableContext from './TableContext.js';

var _templateObject;
var StyledFirstHeaderRowDiv = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", "\n"])), function (_ref) {
  var _table$header;
  var _ref$theme = _ref.theme,
    table = _ref$theme.table,
    palette = _ref$theme.palette,
    hasRowSpan = _ref.hasRowSpan,
    hasSubHeaders = _ref.hasSubHeaders,
    headerLevel = _ref.headerLevel,
    hasChildHeaders = _ref.hasChildHeaders;
  return "".concat(table !== null && table !== void 0 && table.header && hasRowSpan ? "border-bottom-style: ".concat(table.header.borderStyle, ";\n      border-bottom-width: ").concat(table.header.borderWidth, ";\n      border-bottom-color: ").concat(table.header.borderColor && palette[table.header.borderColor], ";") : '', "\n    ").concat(table !== null && table !== void 0 && (_table$header = table.header) !== null && _table$header !== void 0 && _table$header.subHeaderBackgroundColor && hasSubHeaders && headerLevel > 0 ? "background-color: ".concat(palette[table.header.subHeaderBackgroundColor]) : '', "\n    ").concat(hasChildHeaders ? 'text-align: center' : '', "\n    ");
});
var TableHeaderRow = function TableHeaderRow(_ref2) {
  var _ref2$columns = _ref2.columns,
    columns = _ref2$columns === void 0 ? [] : _ref2$columns,
    _ref2$theme = _ref2.theme,
    theme = _ref2$theme === void 0 ? themes["default"] : _ref2$theme,
    sortColumn = _ref2.sortColumn,
    sortable = _ref2.sortable,
    sortingRule = _ref2.sortingRule,
    dataTestId = _ref2['data-testid'];
  var _useContext = useContext(TableContext),
    isSelectable = _useContext.isSelectable;
  var _getHeaderDepth = function getHeaderDepth(column) {
    if (column && column.columns) {
      var maxDepth = 0;
      column.columns.forEach(function (col) {
        maxDepth = Math.max(maxDepth, _getHeaderDepth(col));
      });
      return maxDepth + 1;
    }
    return 0;
  };
  var _getHeaderLevel = function getHeaderLevel(headers, id, level) {
    if (headers.some(function (col) {
      return col.id === id;
    })) {
      return level;
    }
    var nextLevel = 0;
    headers.forEach(function (header) {
      if (header.columns) {
        var lev = _getHeaderLevel(header.columns, id, level + 1);
        if (lev > 0) {
          nextLevel = lev;
        }
      }
    });
    return nextLevel;
  };
  var headerDepth = _getHeaderDepth({
    columns: columns
  });
  var _countChildColumnsReducer = function countChildColumnsReducer(acc, col) {
    if (!acc) {
      acc = 0;
    }
    if (col.columns) {
      acc = col.columns.reduce(_countChildColumnsReducer, acc);
    } else {
      acc = acc + 1;
    }
    return acc;
  };
  var _headerReducer = function headerReducer(acc, cur) {
    cur.level = _getHeaderLevel(columns, cur.id, 0);
    if (cur.columns) {
      cur.colSpan = cur.columns.reduce(_countChildColumnsReducer, 0);
      cur.rowSpan = 1;
    } else {
      cur.isLowestHeader = true;
      cur.colSpan = 1;
      cur.rowSpan = headerDepth - cur.level;
    }
    acc.push(cur);
    if (cur.columns) {
      acc.push.apply(acc, _toConsumableArray(cur.columns.reduce(_headerReducer, [])));
    }
    return acc;
  };
  var headerRows = columns.reduce(_headerReducer, []);
  var groupedHeaders = headerRows.reduce(function (acc, cur) {
    var level = cur.level;
    if (level !== undefined) {
      if (!acc[level]) {
        acc[level] = new Array();
      }
      acc[level].push(cur);
    }
    return acc;
  }, []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, groupedHeaders.map(function (group) {
    return /*#__PURE__*/React.createElement(_TableRow, {
      isFilled: true,
      "data-testid": dataTestId
    }, isSelectable ? /*#__PURE__*/React.createElement(_TableHeaderCol, {
      "aria-label": 'select'
    }) : null, group.map(function (column, index) {
      var handleClick = function handleClick() {
        sortColumn(column);
      };
      var isSortable = sortable && column.isLowestHeader;
      return /*#__PURE__*/React.createElement(_TableHeaderCol, {
        id: column.id,
        key: column.id,
        theme: theme,
        onClick: isSortable ? handleClick : undefined,
        isDescending: isSortable && sortingRule && sortingRule.desc,
        isSorted: isSortable && sortingRule && sortingRule.id === column.id,
        sortable: isSortable,
        rowSpan: column.rowSpan,
        colSpan: column.colSpan,
        hasSubHeaders: headerDepth > 1,
        style: !!column.width ? {
          width: column.width + '%'
        } : undefined
      }, /*#__PURE__*/React.createElement(StyledFirstHeaderRowDiv, {
        hasSubHeaders: headerDepth > 1,
        hasChildHeaders: !!column.columns,
        headerLevel: column.level ? column.level : 0,
        hasRowSpan: column.rowSpan ? column.rowSpan > 1 : false
      }, column.Header));
    }));
  }));
};
var TableHeaderRow$1 = withDefaultTheme(/*#__PURE__*/memo(TableHeaderRow));

export default TableHeaderRow$1;
